import config, { CHAIN } from "@/config/config";
import configBsc from "@/config/config.bsc";
import configPulseChain from "@/config/config.pulsechain";
import { ChainType } from "@/constants/enum/enum";

export const LAST_CONNECTED_WALLET_KEY = "onboard.js:last_connected_wallet";

export const hasPreviousWalletSession = () => {
  const storedWallets = window.localStorage.getItem(LAST_CONNECTED_WALLET_KEY);
  return storedWallets != null && storedWallets !== "" && storedWallets !== "[]";
};

export const createWalletRuntime = async () => {
  const [reactModule, injectedModule, trustModule, coinbaseModule, walletConnectModule] =
    await Promise.all([
      import("@web3-onboard/react"),
      import("@web3-onboard/injected-wallets"),
      import("@web3-onboard/trust"),
      import("@web3-onboard/coinbase"),
      import("@web3-onboard/walletconnect"),
    ]);

  return reactModule.init({
    chains: [
      {
        id: config.chainIdHex,
        token: config.chainSymbol,
        label: config.chainName,
        rpcUrl: config.providerList[0],
      },
    ],
    wallets: [
      injectedModule.default(),
      trustModule.default(),
      coinbaseModule.default(),
      walletConnectModule.default({
        projectId: "05c96d7b6183123d0d09d0b080843541",
        requiredChains: [config.chainId],
        dappUrl: config.domain,
      }),
    ],
    connect: {
      autoConnectLastWallet: true,
      autoConnectAllPreviousWallet: true,
    },
    accountCenter: { desktop: { enabled: false }, mobile: { enabled: false } },
    theme: "dark",
    appMetadata: {
      name: config.title,
      icon:
        CHAIN === ChainType.BNB
          ? `https://${configBsc.domain}/favicon.ico`
          : `https://${configPulseChain.domain}/favicon.ico`,
      description: config.title,
    },
  });
};

export type WalletRuntime = Awaited<ReturnType<typeof createWalletRuntime>>;
